import React from 'react';
import { Button, Divider, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import TopAlignCheckbox from 'components/topAlignCheckbox/TopAlignCheckbox';
import TermsAndConditionsField from '../../../../../components/termsAndConditionsField/TermsAndConditionsField';
import './TermsSection.scss';
import linkImage from 'assets/images/link.svg';
import { buildPolicyPath, buildTermsPath } from 'utils/pathBuilder';

interface TermsSectionProps {
  isReadonly?: boolean;
}

const TermsSection: React.FC<TermsSectionProps> = ({ isReadonly = false }) => {
  const { t } = useTranslation('new_order');

  const handlePersonalInfoClick = () => {
    const url = t('personalInfoLink');
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handlePrivacyPolicyClick = () => {
    window.open(buildPolicyPath(), '_blank', 'noopener,noreferrer');
  };

  const handleTermsClick = () => {
    window.open(buildTermsPath(), '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="terms-section-container">
      {/* Personal Information Collection Statement */}
      <span className="vls-section-title">{t('personalInfoCollection')}</span>

      <div className="personal-info-content">
        {t('personalInfoText')}
        <Button
          type="link"
          onClick={handlePersonalInfoClick}
          className="info-link"
          icon={<img src={linkImage} alt="link" />}
          iconPosition="end"
        >
          {t('personalInfoCollectionStatement')}
        </Button>
      </div>

      <Divider className="section-divider" />

      {/* Service Terms and Conditions */}
      <span className="vls-section-title">{t('serviceTermsConditions')}</span>

      <Form.Item
        name="agreeTerms"
        valuePropName="checked"
        rules={[
          {
            validator: (_, value) => {
              if (value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error(t('agreeTermsRequired')));
            },
          },
        ]}
      >
        {isReadonly ? (
          <TermsAndConditionsField
            isReadonly={true}
            onPrivacyPolicyClick={handlePrivacyPolicyClick}
            onTermsClick={handleTermsClick}
          />
        ) : (
          <TopAlignCheckbox>
            <TermsAndConditionsField
              isReadonly={false}
              onPrivacyPolicyClick={handlePrivacyPolicyClick}
              onTermsClick={handleTermsClick}
            />
          </TopAlignCheckbox>
        )}
      </Form.Item>

    </div>
  );
};

export default TermsSection;